// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/no-array-index-key, react/destructuring-assignment */
import React, { PureComponent, ReactNode } from "react"
// @ts-expect-error: Flow to TS migration.
import keymirror from "keymirror"
import classNames from "classnames"
import Check from "@kiwicom/orbit-components/lib/icons/Check"

import RadioButtonsRadio from "../RadioButtons/RadioButtonsRadio"
import type { SwitchButtonsOption } from "./SwitchButtons.types"

export const SWITCH_BUTTONS_TYPES = keymirror({
  DEFAULT: null,
  DETACHED: null,
  SMALL: null,
})

const ENTER = 13
const SPACE = 32

type Props = {
  active: string
  allowClickActive?: boolean
  forceMobileView?: boolean
  fullwidth: boolean
  multipleLines: boolean
  onChange?: (arg1: string) => void // not required, options can be components with own handlers,
  options: SwitchButtonsOption[] | ReactNode
  optionsAdditionalInfo: ReactNode // Optional info under options buttons,
  selected: string
  theme: string
  type: typeof SWITCH_BUTTONS_TYPES[keyof typeof SWITCH_BUTTONS_TYPES]
  keyAsClass: string
}

export default class SwitchButtons extends PureComponent<Props> {
  static defaultProps = {
    theme: "default", // TODO: Enums
    type: SWITCH_BUTTONS_TYPES.DEFAULT,
  }

  handleChange = (option: SwitchButtonsOption) => {
    const { onChange, active, allowClickActive } = this.props

    if (
      typeof onChange === "function" &&
      !option.disabled &&
      (option.key !== active || allowClickActive)
    ) {
      onChange(option.key)
    }
  }

  renderSimpleOptions = () => {
    const { active, options, selected, type, keyAsClass } = this.props

    if (!Array.isArray(options)) {
      return null
    }

    return (
      <div className="SwitchButtons-options" data-test="SwitchButtons-options">
        {options.map((option) => (
          <div
            data-test={`SwitchButtons-option ${option.key}`}
            key={option.key}
            className={classNames("SwitchButtons-option", {
              _active: option.key === active,
              _selected: option.key === selected,
              _disabled: option.disabled,
              [option.key]: keyAsClass,
            })}
            onClick={() => {
              this.handleChange(option)
            }}
            onKeyDown={(e) => {
              if (e.keyCode === ENTER) {
                this.handleChange(option)
              } else if (e.keyCode === SPACE) {
                e.preventDefault()
                this.handleChange(option)
              }
            }}
            role="button"
            // @ts-expect-error: Flow to TS migration.
            tabIndex={!option.disabled && "0"}
          >
            {type === SWITCH_BUTTONS_TYPES.DETACHED && (
              <RadioButtonsRadio checked={option.key === selected} />
            )}

            <span className="SwitchButtons-option-label">{option.name}</span>

            {option.note && <span className="SwitchButtons-option-note">{option.note}</span>}
          </div>
        ))}
      </div>
    )
  }

  renderSimpleOptionsAdditionalInfo() {
    const { options } = this.props
    if (!Array.isArray(options)) {
      return null
    }
    return (
      <div className="SwitchButtons-additionalInfo">
        {options.map((option) => (
          <div className="SwitchButtons-additionalInfo-item" key={option.key}>
            <ul className="spCheckList">
              {option.additionalInfo.map((info, i) => (
                <li key={i} className="spTypo-caption">
                  <Check ariaHidden size="small" className="spCheckList-icon" />
                  {info}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )
  }

  renderRawOptionsAdditionalInfo = () => (
    <div className="SwitchButtons-additionalInfo">{this.props.optionsAdditionalInfo}</div>
  )

  render() {
    const {
      fullwidth,
      forceMobileView,
      multipleLines,
      options,
      optionsAdditionalInfo,
      theme,
      type,
    } = this.props

    // TODO: Assert (this.props.active !== this.props.selected)
    const hasOptionsAdditionalInfo =
      optionsAdditionalInfo ||
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (Array.isArray(options) && options.some((option) => option.additionalInfo))

    return (
      <div
        className={classNames(
          "SwitchButtons",
          {
            _fullwidth: fullwidth,
            _multipleLines: multipleLines,
            _defaultMobileView: !forceMobileView,
          },
          `_${theme}`,
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `_${type.toLowerCase()}`,
        )}
      >
        {this.renderSimpleOptions()}

        {hasOptionsAdditionalInfo && optionsAdditionalInfo && this.renderRawOptionsAdditionalInfo()}

        {hasOptionsAdditionalInfo &&
          !optionsAdditionalInfo &&
          this.renderSimpleOptionsAdditionalInfo()}
      </div>
    )
  }
}
